<!-- Begin: Admin Form -->

<div class="admin-form">

  <div class="panel">
      <div class="panel-body bg-light">


              <!-- .section-divider -->


                <img [src]="img" style="width: 600px; height: 500px;" />






              <!-- end .form-footer section -->

      </div>

      <div class="panel-footer text-center ">
        <button class="btn btn-primary" mat-dialog-close>Close</button>
    </div>
  </div>

</div>
